<template>
  <search-bar :search="search" class-btn-search="btn btn-primary icon-magnifier form-group right" ref="search">
    <div class="row">
      <div class="col-md-4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" style="width: 65px;">Nome</span>
          </div>
          <input type="text"
                 class="form-control"
                 id="basic-url"
                 aria-describedby="basic-addon3"
                 v-on:keyup.enter="filtrar"
                 placeholder="Nome do usuário"
                 v-model="search.nome"
                 style="width: calc(100% - 65px)">
        </div>
      </div>
      <div class="col-md-4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" style="width: 65px;">E-mail</span>
          </div>
          <input type="text"
                 class="form-control"
                 id="basic-url"
                 aria-describedby="basic-addon3"
                 v-on:keyup.enter="filtrar"
                 placeholder="E-mail do usuário"
                 v-model="search.email"
                 style="width: calc(100% - 65px)">
        </div>
      </div>
      <div class="col-md-4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" style="width: 100px;">Tipo Usuário</span>
          </div>
          <select type="text"
                  class="form-control"
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  v-on:keyup.enter="filtrar"
                  v-model="search.tipo_contratacao_id"
                  style="width: calc(100% - 100px)">
            <option value="">Todos</option>
            <option v-for="item of dados.tiposContratacao" v-bind:key="item.id" :value="item.id">{{ item.tipo_contratacao }}</option>
          </select>
        </div>
      </div>
    </div>
  </search-bar>
</template>

<script>
  import { SearchBar } from 'metawesome-datatable';
  import Uteis from '@/mixins/utils.js';


  export default {
    components: {
      SearchBar,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        search: {
          nome: '',
          email: '',
          tipo_contratacao_id: '',
        },
        dados: {
          tiposContratacao: [],
        }
      };
    },

    mounted() {
      this.$refs.search.$on('filter-set', (filter) => {
        this.$emit('filter-set', filter);
      });

      this.filtrar();
      this.getTiposContratacao();
    },

    methods: {
      async getTiposContratacao() {
        try {
          this.dados.tiposContratacao = [];

          const { data: response } = await this.$http.get('/tipo-contratacao');
          this.dados.tiposContratacao = response.data;
        } catch(e) {
          this.notificar('Ocorreu um erro ao pesquisar as Formas de Contratações.', 'listagem-usuarios');
        }
      },

      filtrar() {
        this.$emit('filter-set', this.search);
      },
    }
  };
</script>
